import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { ExclusionGroupConfig } from '@portal/app/shared/types';

@Component({
  selector: 'portal-halo-spend-modal',
  templateUrl: './halo-spend-modal.component.html',
  styleUrls: ['./halo-spend-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HaloSpendModalComponent {
  @Input() visible = false;
  @Input() exclusionGroupConfig: ExclusionGroupConfig | null = null;
  @Input() currentBrandName = '';
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() enable = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<boolean>();

  dontShowAgain = false;
  private suppressNextClose = false;

  onEnable(): void {
    this.suppressNextClose = true;
    this.visible = false;
    this.visibleChange.emit(false);
    this.enable.emit(this.dontShowAgain);
  }

  onClose(): void {
    if (this.suppressNextClose) {
      this.suppressNextClose = false;
      return;
    }
    this.visible = false;
    this.visibleChange.emit(false);
    this.closed.emit(this.dontShowAgain);
  }

  onDontShowAgainChange(event: { checked: boolean }): void {
    this.dontShowAgain = event.checked;
  }
}
